export default "__VITE_ASSET__B778nHku__"